@if(form) {
  <mat-form-field [formGroup]="form" appearance="outline" color="primary" class="textarea-field withoutBottomValidation" [class]="this.className">
      @if (this.label) {
          <mat-label>{{this.label}}</mat-label>
      }  
      <textarea
        cdkTextareaAutosize
        #autosize="cdkTextareaAutosize"
        cdkAutosizeMinRows="1"
        cdkAutosizeMaxRows="10"
        matInput
        [id]="this.key"
        [type]="this.type || 'text'"
        [formControlName]="this.key"
        [readonly]="this.readonly"
        [name]="this.key"
        [value]="this.value"
        (blur)="handleOnBlur($event)"
        [placeholder]="this.placeholder"
        (input)="handleOnInput($event)"
        [maxLength]="this.maxLength"
        class="!min-h-[64px]"></textarea>
        @let customError = getCustomError(control);
        @if (customError) {
            <mat-error>
                {{ customError }}
            </mat-error>
        }
        @if(this.hint) {
            <mat-hint>{{ this.hint }}</mat-hint>
        }
  </mat-form-field>
  } @else {
  <mat-form-field appearance="outline" color="primary" class="textarea-field withoutBottomValidation" [class]="this.className">
      <mat-label>{{this.label}}</mat-label>
      <textarea
            matInput
            [id]="this.key"
            [type]="this.type || 'text'"
            [name]="this.key"
            [value]="this.value"
            (blur)="handleOnBlur($event)"
            [placeholder]="this.placeholder"
            [maxLength]="this.maxLength"
            class="!min-h-[64px]"
        ></textarea>
      @if(this.hint) { 
        <mat-hint>{{ this.hint }}</mat-hint>
      }
  </mat-form-field>
  }
    <span class="flex justify-end">{{ this.valueLength }}/{{ this.maxLength }}</span>
